import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import OrganizationType from './OrganizationType';
import './CreateAccountScene.scss';
import UserRole from './UserRole';
import SignUp from '../SignUp';
import CreateEventLandingPage from 'scenes/V3/CreateEventLandingPage';
import AthleticTrainerSignUp from '../SignUp/AthleticTrainer/AthleticTrainerSignUp';

class CreateAccountScene extends Component {
  renderRoute = (route, Component) => {
    const { match } = this.props;

    return <Route exact path={`${match.url}/${route}`} render={props => <Component {...props} />} />;
  };

  render() {
    return (
      <div className="v2CreateAccountScene">
        <main className="content gotham-regular-font">
          {this.renderRoute('', CreateEventLandingPage)}
          {this.renderRoute('organization-type', OrganizationType)}
          {this.renderRoute('role', UserRole)}
          {this.renderRoute('sign-up', SignUp)}
          {this.renderRoute('athletic-trainer-sign-up', AthleticTrainerSignUp)}
        </main>
      </div>
    );
  }
}

export default CreateAccountScene;
